<template>
    <section id='login-user'>
        <div class="row">
            <div class="col-12 text-center">
                <br>
                <h2>Anmelden</h2>
                <br>
            </div>
        </div>
        <div class="row backgroundGray">
            <div class="row">
                <div class="col-12">
                    <div :class="formGroupClass('email')">
                        <div class="form-group">
                            <input class="form-control" id="email" type="email" name="email" placeholder="E-Mail" v-model="form.email" required="required"/>
                            <div class="help-block" v-if="error">
                                <strong>{{ error }}</strong>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div :class="formGroupClass('password')">
                        <div class="form-group">
                            <input class="form-control" id="password" type="password" name="password" placeholder="Passwort eingeben" v-model="form.password" required="required"/>
                        </div>
                    </div>
                </div>
                <div class="col-12 text-center registerText">
                    Sie haben noch kein Konto? <a href="\register">Jetzt registrieren</a>
                </div>
                <div class="col-12 text-center">
                    <br>
                    <button type="button" class="btn btn-success login" @click="login">Anmelden</button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

export default {

    data() {
        return {
            loading: false,
            form: new Form({
                email: null,
                password: null
            }),
            error: null
        };
    },

    methods: {
        formGroupClass(name) {
            return this.form.errors.has(name) ? 'form-group has-error' : 'form-group';
        },

        login() {
            this.form.post('/login').then(response => {
                window.axios.defaults.headers.common["X-CSRF-TOKEN"] = response.user.csrf_token;
                App.event.fire('login.success', response);
            }).catch(errors => {
                this.error = errors.errors.email[0];
            });
        }
    },

    created() {

    }
}
</script>
